<div class="integrations-container">

  <div class="integrations-grid">
    <div class="integration-card" *ngFor="let integration of integrations" [class.connected]="integration.connected">
      <div class="card-content">
        <div class="integration-icon" [ngClass]="'icon-' + integration.id"></div>
        
        <h3 class="integration-name">{{ integration.name }}</h3>
        
        <p class="integration-description">{{ integration.description }}</p>
        
        <button class="btn-connect" (click)="connectIntegration(integration)">
          <span>Connect</span>
          <img src="/assets/img/icons/connect.svg" alt="Connect icon" width="16" height="16">
        </button>
      </div>
    </div>

    <div class="integration-card placeholder-card" *ngFor="let placeholder of placeholderCards">
      <div class="card-content">
        <div class="integration-icon icon-placeholder"></div>
        
        <h3 class="integration-name">Missing a tool?</h3>
        
        <p class="integration-description">Contact us to request an integration.</p>
        
        <button class="btn-request" (click)="requestIntegration()">
          <span>Request an Integration</span>
        </button>
      </div>
    </div>
  </div>
</div>

<ng-template #integrationModal let-modal>
  <div class="modal-content">
    <div class="modal-header">
      <button
        type="button"
        class="btn-close"
        aria-label="Close"
        (click)="modal.dismiss('Cross click')"
      ></button>
    </div>
    <div class="modal-body">
      <div class="text-center">
        <div class="fs-15 mx-4 mx-sm-5">
          <h4>Integrations</h4>
          <p class="mt-3">
            This is an Enterprise-only service. Please contact our team to get access to Integrations.
          </p>
        </div>
      </div>
      <div class="d-flex justify-content-center mt-3 mb-2">
        <button
          class="btn btn-primary"
          (click)="talkToSales(); modal.close('Contact us')"
        >
          Contact us
        </button>
      </div>
    </div>
  </div>
</ng-template>

